/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateConditionRequest
 */
export interface UpdateConditionRequest {
    /**
     * サービス種別
     * @type {number}
     * @memberof UpdateConditionRequest
     */
    serviceCategory: UpdateConditionRequestServiceCategoryEnum;
    /**
     * 金銭区分
     * @type {number}
     * @memberof UpdateConditionRequest
     */
    moneyCategory: UpdateConditionRequestMoneyCategoryEnum;
    /**
     * 費目名
     * @type {string}
     * @memberof UpdateConditionRequest
     */
    expenseItemName: string;
    /**
     * 手数料率
     * @type {number}
     * @memberof UpdateConditionRequest
     */
    feePercentage: number;
    /**
     * 税区分
     * @type {number}
     * @memberof UpdateConditionRequest
     */
    taxKind: UpdateConditionRequestTaxKindEnum;
    /**
     * 集計期間区分 1=1日〜月末 2=A: 1日〜15日,B: 16日〜月末
     * @type {number}
     * @memberof UpdateConditionRequest
     */
    aggregationPeriodKind: UpdateConditionRequestAggregationPeriodKindEnum;
    /**
     * 精算処理日区分 1=翌月1日 2=A: 当月16日,B: 翌月1日
     * @type {number}
     * @memberof UpdateConditionRequest
     */
    processingPeriodKind: UpdateConditionRequestProcessingPeriodKindEnum;
    /**
     * 備考
     * @type {string}
     * @memberof UpdateConditionRequest
     */
    description?: string;
}


/**
 * @export
 */
export const UpdateConditionRequestServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type UpdateConditionRequestServiceCategoryEnum = typeof UpdateConditionRequestServiceCategoryEnum[keyof typeof UpdateConditionRequestServiceCategoryEnum];

/**
 * @export
 */
export const UpdateConditionRequestMoneyCategoryEnum = {
    OVERSEAS_APP_PLATFORM_SALES: 0,
    TIP: 1,
    CANCELLATION_FEE: 2,
    TAXIFARE: 3
} as const;
export type UpdateConditionRequestMoneyCategoryEnum = typeof UpdateConditionRequestMoneyCategoryEnum[keyof typeof UpdateConditionRequestMoneyCategoryEnum];

/**
 * @export
 */
export const UpdateConditionRequestTaxKindEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type UpdateConditionRequestTaxKindEnum = typeof UpdateConditionRequestTaxKindEnum[keyof typeof UpdateConditionRequestTaxKindEnum];

/**
 * @export
 */
export const UpdateConditionRequestAggregationPeriodKindEnum = {
    ONCE_MONTH: 1,
    TWICE_MONTH: 2
} as const;
export type UpdateConditionRequestAggregationPeriodKindEnum = typeof UpdateConditionRequestAggregationPeriodKindEnum[keyof typeof UpdateConditionRequestAggregationPeriodKindEnum];

/**
 * @export
 */
export const UpdateConditionRequestProcessingPeriodKindEnum = {
    ONCE_MONTH: 1,
    TWICE_MONTH: 2
} as const;
export type UpdateConditionRequestProcessingPeriodKindEnum = typeof UpdateConditionRequestProcessingPeriodKindEnum[keyof typeof UpdateConditionRequestProcessingPeriodKindEnum];


/**
 * Check if a given object implements the UpdateConditionRequest interface.
 */
export function instanceOfUpdateConditionRequest(value: object): value is UpdateConditionRequest {
    if (!('serviceCategory' in value) || value['serviceCategory'] === undefined) return false;
    if (!('moneyCategory' in value) || value['moneyCategory'] === undefined) return false;
    if (!('expenseItemName' in value) || value['expenseItemName'] === undefined) return false;
    if (!('feePercentage' in value) || value['feePercentage'] === undefined) return false;
    if (!('taxKind' in value) || value['taxKind'] === undefined) return false;
    if (!('aggregationPeriodKind' in value) || value['aggregationPeriodKind'] === undefined) return false;
    if (!('processingPeriodKind' in value) || value['processingPeriodKind'] === undefined) return false;
    return true;
}

export function UpdateConditionRequestFromJSON(json: any): UpdateConditionRequest {
    return UpdateConditionRequestFromJSONTyped(json, false);
}

export function UpdateConditionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateConditionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceCategory': json['service_category'],
        'moneyCategory': json['money_category'],
        'expenseItemName': json['expense_item_name'],
        'feePercentage': json['fee_percentage'],
        'taxKind': json['tax_kind'],
        'aggregationPeriodKind': json['aggregation_period_kind'],
        'processingPeriodKind': json['processing_period_kind'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UpdateConditionRequestToJSON(json: any): UpdateConditionRequest {
    return UpdateConditionRequestToJSONTyped(json, false);
}

export function UpdateConditionRequestToJSONTyped(value?: UpdateConditionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_category': value['serviceCategory'],
        'money_category': value['moneyCategory'],
        'expense_item_name': value['expenseItemName'],
        'fee_percentage': value['feePercentage'],
        'tax_kind': value['taxKind'],
        'aggregation_period_kind': value['aggregationPeriodKind'],
        'processing_period_kind': value['processingPeriodKind'],
        'description': value['description'],
    };
}

